<template>
    <div>
        <v-card
                class="elevation-12 mb-4"
                color="#488ba6"
                dark
        >
            <div v-if="!state.payment.response.errorMsg">
                <v-alert v-if="state.appStage.sendingAttachments" type="warning">
                    Uploading your attachments
                </v-alert>
                <v-alert v-else type="success">
                    Attachments Uploaded!
                </v-alert>
                <v-card-title class="headline" v-if="state.payment.response.text === 'ZERO TOTAL'">Thank you!
                </v-card-title>
                <v-card-title class="headline" v-else>{{state.payment.response.text}}
                </v-card-title>

                <v-card-subtitle>Application Name: {{state.payment.response.master.first_name}} {{state.payment.response.master.last_name}}
                </v-card-subtitle>
                <v-card-text v-if="state.payment.response.code == 1">
                    <p>
                        Your FVS Application has been submitted and your payment was a success! Please check your email for your transaction receipt. Please keep in mind that your application may not be approved until you have submitted all of your required attachments:
                    </p>
                    <ul>
                        <li v-for="(file, index) in state.member.attachments" :key="index">{{file.label}}</li>
                    </ul>
                    <br>
                    <p>Please send any remaining attachments you have not submitted already to <a style="color:white" href="mailto:membership@fvs.org">membership@fvs.org</a>.</p>
                </v-card-text>
                <v-simple-table light>
                    <thead>
                    <tr>
                        <th class="text-left">Product</th>
                        <th class="text-right">Price</th>
                    </tr>
                    <tr>
                        <td class="text-left">{{state.member.app.membershipType.text}} Member Application</td>
                        <td class="text-right">{{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(state.member.app.membershipType.fee)}}</td>
                    </tr>
                    <tr v-if="state.payment.promoCode.PROMOID">
                      <td class="text-left">Promocode: {{state.payment.promoCode.code}}</td>
                      <td class="text-right">{{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(state.payment.promoCode.factor)}}</td>
                    </tr>
<!--                    <tr v-if="parseInt(state.payment.response.subscription.subscription_id) > 0">
                      <td class="text-left">Subscription discount </td>
                      <td class="text-right">{{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(state.payment.response.subscription.discount)}}</td>
                    </tr>-->
                    <tr v-if="!state.payment.response.subscription.subscription_message || state.payment.response.subscription.subscription_message===''">
                      <td class="text-left"> Subscription Autopay Dues</td>
                      <td class="text-right">Successfully Settled </td>
                    </tr>
                    <tr v-else>
                      <td class="text-left">Subscription </td>
                      <td class="text-right"> Subscription was declined: {{state.payment.response.subscription.subscription_message}} </td>
                    </tr>
                    <tr v-if="state.payment.promoCode.PROMOID">
                        <td class="text-left">Total</td>
                        <td class="text-right">{{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(parseFloat(state.member.app.membershipType.fee) + parseFloat(state.payment.promoCode.factor) )}}</td>
                    </tr>
                    <tr v-else>
                      <td class="text-left">Total</td>
                      <td class="text-right">{{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(parseFloat(state.member.app.membershipType.fee) )}}</td>
                    </tr>
                    </thead>
                </v-simple-table>
                <v-card-text>
                    <p>Card Ending In: {{state.payment.cc.number.substr(state.payment.cc.number.length - 4)}}</p>
                    <p>Card Name: {{state.payment.cc.firstName}} {{state.payment.cc.lastName}}</p>
                    <p>Receipt Sent to: {{state.payment.response.receiptTo}}</p>
                </v-card-text>
            </div>
            <div v-else>

            </div>

        </v-card>

    </div>
</template>

<script>

    import {mapGetters} from 'vuex'

    export default {
        name: "Success",
        computed: {
            ...mapGetters({
                state: 'getState',
            }),
        },
    }
</script>

<style scoped>

</style>